import React, {useContext, useEffect, useState} from 'react';
import getWithAuth from "../../context/getWithAuth";
import userContext from "../../context/userContext";
import Loader from "../../components/loader";
import ToSModal from "../../components/tosModal";
import {useNavigate} from "react-router-dom";
import GradeLevelSummaryBlock from "./gradeLevelSummaryBlock";
import LocalLoaderLight from "../../components/localLoaderLight";

function BuildingSummary(props) {
    const [schoolSummary, setSchoolSummary] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        const oneWeekAgo = new Date(today);
        oneWeekAgo.setDate(today.getDate() - 7);

        return oneWeekAgo.toISOString().split("T")[0];
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    });

    const user = useContext(userContext)
    let navigate = useNavigate()

    const getSchoolSummary = async () => {
        if (user.userAttributes) {
            try {
                getWithAuth('/building/getSchoolSummary', user.userAttributes['custom:school'], {userId: user.userContext._id.$oid, startDate: startDate, endDate: endDate})
                    .then(async r => {
                        setSchoolSummary(r)
                    })
                    .then(() => setIsLoading(false))
            } catch (error) {
                console.error('Error fetching standards data:', error)
            }
        }
    }

    const handleUpdateClick = () => {
        setIsLoading(true);
        getSchoolSummary();
    }

    useEffect(() => {
        setIsLoading(true)
        getSchoolSummary()
    }, [user.userContext])

    if (!user.userContext) {
        return <Loader message={'Fetching User Data'}/>
    } else if (!user.userContext.termsAccepted) {
        return <ToSModal user={user}/>
    } else if (user.userContext.role !== 'coordinator') {
        navigate('/')
    } else if (isLoading || !schoolSummary) {
        const loadingItems = [
            (!schoolSummary || isLoading) && "Learning Data",
        ].filter(Boolean); // Filter out false/null values

        const fetchingText = loadingItems.length > 1
            ? `Fetching: ${loadingItems.slice(0, -1).join(", ")} and ${loadingItems.slice(-1)}`
            : `Fetching: ${loadingItems[0] || ""}`;
        return <div className={'bg-columbia_blue-900 mx-1 min-h-full py-20 rounded-b rounded-tr shadow'}>
            <LocalLoaderLight message={fetchingText}/>
        </div>
    } else {
        return (
            <>
                <div className={'flex flex-col bg-columbia_blue-900 mx-1 rounded-b shadow'}>
                    <div className={'grid grid-cols-3 my-2'}>
                        <div>
                            <p className={'select-none text-dutch_white-200'}>Start Date:</p>
                            <input className={'bg-dutch_white-100 rounded p-2'} type={"date"} value={startDate}
                                   onChange={(e) => setStartDate(e.target.value)} />

                        </div>
                        <button className={'rounded bg-columbia_blue-500 hover:bg-columbia_blue-400 cursor-pointer'} onClick={handleUpdateClick}>Update Data Summary</button>
                        <div>
                            <p className={'select-none text-dutch_white-200'}>End Date:</p>
                            <input className={'bg-dutch_white-100 rounded p-2'} type={"date"} value={endDate}
                                   onChange={(e) => setEndDate(e.target.value)}/>

                        </div>
                    </div>
                    <div className={'flex max-w-full'}>
                    {schoolSummary.sort((a, b) => Number(a.grade) - Number(b.grade)).map(item => <GradeLevelSummaryBlock
                        user={user} data={item}/>)}
                    </div>
                </div>
            </>
        );
    }
}

export default BuildingSummary;